<template>
    <div class="cartWrap fc">
        <h3>共{{totalNum}}件商品</h3>
        <div class="cartItems" v-show="cartList.length">
            <div class="itemWrap" v-for="(item, index) in cartList" :key="index" data-type="0">
                <div
                    class="cartItem fr ac"
                    @touchstart.capture="touchStart"
                    @touchend.capture="touchEnd"
                >
                    <img
                        @click="switchSelect(index)"
                        class="selectIcon"
                        :src="item.isSelect ? selectedIconPath : selectIconPath"
                        alt
                    />
                    <img class="itemImg" :src="item.logo" alt />
                    <div class="itemInfo fc jsb">
                        <span class="itemName">{{item.productName}}</span>
                        <span class="sku">{{item.skuName}}</span>
                        <div class="fr ac jsb">
                            <span class="price">{{item.sellPrice}}</span>
                            <div class="quantity">
                                <span
                                    @click="editNum('minus', index, item.cartItemId, item.qty)"
                                    class="minus"
                                >-</span>
                                <span class="num">{{item.qty}}</span>
                                <span
                                    @click="editNum('add', index, item.cartItemId, item.qty)"
                                    class="add"
                                >+</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div @click.stop="delItem(item.cartItemId)" class="deleteBtn center">删除</div>
            </div>
        </div>
        <div class="footer fr ac jsb">
            <div class="left fr ac">
                <div class="selectAll fr ac" @click="switchSelectAll">
                    <img :src="isSelectAll ? selectedIconPath : selectIconPath" alt />
                    <span>全选</span>
                </div>
                <span class="total">
                    总计
                    <strong>￥{{totalPrice}}</strong>
                </span>
            </div>
            <button class="payBtn" @click="toOrderInfo">去支付</button>
        </div>
        <div class="placeholder fc ac" v-show="!cartList.length">
            <img src="../../../static/imgs/mall/planet.png" alt="">
            <span>购物车竟然是空的</span>
            <button @click="$router.push('/mallIndex')">去逛逛</button>
        </div>
    </div>
</template>

<script>
import { MessageBox, Toast } from "mint-ui";
export default {
    data() {
        return {
            cartList: [],
            startX: 0,
            endX: 0,
            selectIconPath: require("../../../static/imgs/mall/select.png"),
            selectedIconPath: require("../../../static/imgs/mall/selected.png"),
            isSelectAll: false, //是否全选
            totalPrice: 0, //总计价格
            totalNum: 0 //商品总件数
        };
    },
    components: {},
    created() {
        this.getCartList();
    },
    methods: {
        getCartList() {
            this.$post({
                method: "member.mall.cart.list",
                auth_code: this.getLocal("auth_code")
            }).then(res => {
                if (res.success) {
                    this.cartList = res.data;
                    this.caculateNum();
                }
            });
        },
        editNum(type, idx, id, qty) {
            switch (type) {
                case "add":
                    this.cartList[idx].qty++;
                    qty++;
                    this.editCart(id, qty);
                    this.caculateTotal();
                    this.caculateNum();
                    break;
                case "minus":
                    if (qty < 2) {
                        Toast({
                            message: "不能再减啦",
                            position: "middle",
                            duration: 1500,
                            className: "toastBox"
                        });
                    } else {
                        this.cartList[idx].qty--;
                        qty--;
                        this.editCart(id, qty);
                        this.caculateTotal();
                        this.caculateNum();
                    }
            }
        },
        editCart(id, qty) {
            this.$post({
                method: "member.mall.cart.edit",
                auth_code: this.getLocal("auth_code"),
                qty: qty,
                cartItemId: id
            }).then(res => {});
        },
        delItem(id) {
            MessageBox.confirm("确定删除此商品?")
                .then(action => {
                    if (action == "confirm") {
                        this.$post({
                            method: "member.mall.cart.del",
                            cartItemId: id,
                            auth_code: this.getLocal("auth_code")
                        }).then(res => {
                            if (res.success) {
                                this.getCartList();
                                this.restSlide();
                                this.caculateNum();
                            }
                        });
                    }
                })
                .catch(err => {
                    this.restSlide();
                });
        },
        switchSelect(idx) {
            this.$set(
                this.cartList[idx],
                "isSelect",
                this.cartList[idx].isSelect ? false : true
            );
            for (let i of this.cartList) {
                if (!i.isSelect) {
                    this.isSelectAll = false;
                    break;
                } else {
                    this.isSelectAll = true;
                }
            }
            this.caculateTotal();
        },
        switchSelectAll() {
            this.isSelectAll = !this.isSelectAll;
            this.cartList.forEach(i => {
                this.$set(i, "isSelect", this.isSelectAll);
            });
            this.caculateTotal();
        },
        // 计算总价
        caculateTotal() {
            let total = 0;
            for (let i of this.cartList) {
                if (i.isSelect) {
                    total += i.sellPrice * i.qty;
                }
            }
            this.totalPrice = total;
        },
        // 计算商品件数
        caculateNum() {
            let num = 0;
            for (let i of this.cartList) {
                num += i.qty;
            }
            this.totalNum = num;
        },
        //滑动开始
        touchStart(e) {
            // 记录初始位置
            this.startX = e.touches[0].clientX;
        },
        //滑动结束
        touchEnd(e) {
            // 当前滑动的父级元素
            let parentElement = e.currentTarget.parentElement;
            // 记录结束位置
            this.endX = e.changedTouches[0].clientX;
            // 左滑
            if (
                parentElement.dataset.type == 0 &&
                this.startX - this.endX > 30
            ) {
                this.restSlide();
                parentElement.dataset.type = 1;
            }
            // 右滑
            if (
                parentElement.dataset.type == 1 &&
                this.startX - this.endX < -30
            ) {
                this.restSlide();
                parentElement.dataset.type = 0;
            }
            this.startX = 0;
            this.endX = 0;
        },
        //复位滑动状态
        restSlide() {
            let listItems = document.querySelectorAll(".itemWrap");
            // 复位
            for (let i = 0; i < listItems.length; i++) {
                listItems[i].dataset.type = 0;
            }
        },
        toOrderInfo() {
            let selectedItemArr = [];
            this.cartList.forEach(i => {
                if (i.isSelect) {
                    selectedItemArr.push(i);
                }
            });
            if (!selectedItemArr.length) {
                Toast({
                    message: "请先选择商品",
                    position: "middle",
                    duration: 1500,
                    className: "toastBox"
                });
                return;
            }
            this.$router.push({path: "/mallOrderInfo", query: { productList: JSON.stringify(selectedItemArr), origin: "cart"}})
        }
    }
};
</script>
<style lang="scss">
.cartWrap {
    h3 {
        width: 100%;
        padding: 0 20px;
        height: 100px;
        line-height: 100px;
        font-size: 32px;
    }
    .cartItems {
        width: calc(100% - 40px);
        margin: 0 20px 130px 20px;
        overflow: hidden;
        border-radius: 10px;
        .itemWrap {
            position: relative;
            -webkit-transition: all 0.2s;
            transition: all 0.2s;
            .cartItem {
                width: 100%;
                padding: 30px;
                height: 280px;
                background: #fff;
                border-bottom: 1px solid #dededf;
                .selectIcon {
                    width: 30px;
                    height: 30px;
                    margin: 0 30px 0 10px;
                }
                .itemImg {
                    width: 218px;
                    height: 218px;
                    border: 1px solid #dededf;
                    border-radius: 20px;
                }
                .itemInfo {
                    width: calc(100% - 290px);
                    padding-left: 30px;
                    box-sizing: border-box;
                    height: 220px;
                    .itemName {
                        font-size: 28px;
                        line-height: 36px;
                    }
                    .sku {
                        font-size: 24px;
                        color: #999;
                    }
                    .price {
                        color: #fe5200;
                        font-size: 28px;
                    }
                    .quantity {
                        border: 1px solid #999;
                        border-radius: 5px;
                        span {
                            display: inline-block;
                            line-height: 48px;
                            text-align: center;
                        }
                        .add,
                        .minus {
                            width: 48px;
                            height: 48px;
                        }
                        .num {
                            width: 68px;
                            height: 48px;
                            border-right: 1px solid #999;
                            border-left: 1px solid #999;
                        }
                    }
                }
            }
            .deleteBtn {
                width: 120px;
                position: absolute;
                right: -120px;
                top: 0;
                background: #ed726e;
                height: 280px;
                font-size: 32px;
                color: #fff;
            }
        }
        .itemWrap[data-type="0"] {
            transform: translate3d(0, 0, 0);
        }
        .itemWrap[data-type="1"] {
            transform: translate3d(-120px, 0, 0);
        }
        .itemWrap:last-of-type {
            .cartItem {
                border-bottom: none;
            }
        }
    }
    .footer {
        width: 100%;
        height: 100px;
        position: fixed;
        bottom: 0;
        background: #fff;
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 28px;
        .left {
            .selectAll {
                margin-right: 30px;
                img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                }
            }
            .total {
                strong {
                    color: #fe5200;
                }
            }
        }
        .payBtn {
            width: 160px;
            height: 60px;
            line-height: 60px;
            border-radius: 10px;
            background: #fc0;
        }
    }
    .placeholder {
        margin-top: 140px;
        font-size: 28px;
        img {
            width: 168px;
            height: 168px;
        }
        span {
            margin: 40px 0 50px 0;
        }
        button {
            width: 182px;
            height: 66px;
            line-height: 66px;
            background: none;
            border:1px solid #999;
            border-radius:10px;
        }
    }
}
.mint-msgbox {
    font-size: 28px !important;
    border-radius: 10px;
    .mint-msgbox-header {
        padding-top: 30px;
        .mint-msgbox-title {
            font-size: 30px !important;
        }
    }
    .mint-msgbox-content {
        padding: 30px;
    }
    .mint-msgbox-btns {
        height: 70px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/cart.vue